/**
 * Icon constants for UI elements
 * These icons are used across the application for buttons, indicators, and other UI elements
 *
 * Currently contains action icons for conversation supervision actions.
 * Additional icon categories can be added here in the future.
 */
export default {
    // Monitor action icons
    MONITOR: "fa/binoculars-regular",
    STOP_MONITOR: "custom/regular-binoculars-slash",

    // Coach action icons
    COACH: "fa/whistle-regular",
    STOP_COACH: "custom/whistle-slash-regular",

    // Barge-in action icons
    BARGE_IN: "fa/bullhorn-regular",
    STOP_BARGE_IN: "custom/bullhorn-slash-regular",

    // Screen monitor action icons
    SCREEN_MONITOR: "fa/display-regular",
    STOP_SCREEN_MONITOR: "fa/regular-display-slash",

    AUTHENTICATED_USER: "shield-solid",

    // Participant icons
    SINGLE_INTERNAL_PARTICIPANT: "fa/headset-solid",
    SINGLE_EXTERNAL_PARTICIPANT: "user-circle",
    MULTIPLE_INTERNAL_PARTICIPANTS: "custom/users-headset-regular",
    MULTIPLE_EXTERNAL_PARTICIPANTS: "fa/user-group-solid",
    MISSING_PARTICIPANT: "fa/xmark-large-regular",

    // UI control icons
    COPY_BUTTON: "copy",
    DROPDOWN_ICON: "chevron-small-down",
    HIDE_SUPERVISORS_ICON: "fa/caret-down-solid",
    SHOW_SUPERVISORS_ICON: "fa/caret-right-solid",
    TRANSFER: "transfer",
    FILTER: "fa/filter-solid",
    COLLAPSABLE_TEXT_EXPAND: "chevron-small-down",
    COLLAPSABLE_TEXT_COLLAPSE: "chevron-small-up",

    // Media control icons
    PLAY: "fa/play-solid-full",
};
